import React from 'react';
import { map, slice, noop, merge } from 'lodash';

// local dependencies
import { WIDGET_NAMES } from 'constants/entity-names';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { DrugPricingDrugSearch } from 'ui/containers/DrugPricingDrugSearch';
import { DrugPricingDrugDetail } from 'ui/containers/DrugPricingDrugDetail';
import { DrugPricingPharmacyLocator } from 'ui/containers/DrugPricingPharmacyLocator';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';

// step views
const DRUG_SEARCH_STEP_VIEWS = {
    [ WIDGET_NAMES.DRUG_PRICING_DRUG_SEARCH ]: DrugPricingDrugSearch,
    [ WIDGET_NAMES.DRUG_PRICING_DRUG_DETAIL ]: DrugPricingDrugDetail,
    [ WIDGET_NAMES.DRUG_PRICING_PHARMACY_LOCATOR ]: DrugPricingPharmacyLocator,
};

/*******************************/

// success view
export const drugSearchSuccess = ( props ) => {

    // get steps based on `activeStepIndex` value
    const steps = slice( props.steps, 0, props.activeStep );

    return (
        <div className='ui-drug-search'>

            {/* back action */}
            <div className='ui-drug-search__action'>
				{ map( props.navActions, ( navAction ) => {

					// get the action for navAction
					const iconId = 'back' === navAction.name ? 'backArrow' : null;

					return (
						<div
							className='ui-drug-search__action__nav-action'
							key={ navAction.name }
							onClick={ () =>
								props.onNavActionClick( {
									type: 'headerAction',
									value: navAction,
								} )
							}
						>
							<Icon id={ iconId } />
							<div className='ui-drug-search__action__nav-action__label'>
								{ getLabel( navAction.title ) }
							</div>
						</div>
					);
				} ) }
			</div>

            <div className='ui-drug-search__steps'>
                {
                    map( steps, step => {
                        
                        // step view
                        const StepView = DRUG_SEARCH_STEP_VIEWS[ step.name ];

                        /*--------*/

                        // request payload for each step
                        let requestPayload = props.requestPayload;

                        if( step.name === WIDGET_NAMES.DRUG_PRICING_DRUG_DETAIL ) {
                            requestPayload = merge( requestPayload, {
                                data: {
                                    drug: props.selectedDrugValue,
                                }
                            } );
                        } else if( step.name === WIDGET_NAMES.DRUG_PRICING_PHARMACY_LOCATOR ) {
                            requestPayload = merge( requestPayload, {
                                data: {
                                    drug: props.selectedDrugValue,
                                    drugNdc: props.drugNdc,
                                    filters: props.drugFilters,
                                },
                            } );
                        }

                        /*--------*/

                        return (
                            <div key={ step.name } className='ui-drug-search__steps__step'>
                                <StepView
                                    widget={ step }
                                    onDrugSearchQueryChange={ props.onDrugSearchQueryChange }
                                    onDrugSelect={ props.onDrugSelect }
                                    onDrugFilterChange={ props.onDrugFilterChange }
                                    onViewPrice={ props.onViewPrice }
                                    requestPayload={ requestPayload }
                                />
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
drugSearchSuccess.displayName = 'drugSearchSuccess';

// set default props
drugSearchSuccess.defaultProps = {
    requestPayload: {},
    activeStep: 1,
    steps: [],
    onDrugSearchQueryChange: noop,
    onDrugSelect: noop,
    onDrugFilterChange: noop,
    onViewPrice: noop,
};

// prop types
drugSearchSuccess.propTypes = {};

/*******************************/

// preloader view
export const drugSearchPreloader = () => {
    return (
        <div className='ui-drug-search-preloader'>
            <WidgetPreloader className='ui-drug-search-preloader__preloader'/>
        </div>
    );
};

// set display name
drugSearchPreloader.displayName = 'drugSearchPreloader';

// set default props
drugSearchPreloader.defaultProps = {};

// prop types
drugSearchPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { drugSearch as DrugSearch } from 'ui/views/widgets/drugSearch';
 *
 * // render
 * <DrugSearch propName='propValue'/>
 */
export const drugSearch = withNetworkState( drugSearchPreloader, drugSearchSuccess );
